import classNames from 'classnames';

import ActionMenu from 'common/ActivityChip/ActionMenu';
import { getActivityActions } from 'common/ActivityChip/ActionMenu/actionMenuFactory';
import { useActivityMutations } from 'common/ActivityChip/ActionMenu/useActivityMutation';
import { useChipModalOpener } from 'common/ActivityChip/useMakeChipModalOpener';
import { formatTime, getDurationBetweenTimestamps } from 'utils/datetime';

import styles from 'common/ActivityChip/styles.module.css';

const RestLayout = ({
	config,
	timezone,
	isSelected,
	isStartInTimeWindow = true,
	isEndInTimeWindow = true,
	suppressNativeTitle = false,
}) => {
	const { renderType, header, icon, subline, fromTimestamp, toTimestamp, raw, crewMemberId } =
		config;

	const openModalForChip = useChipModalOpener();
	const { updateBreak, loading } = useActivityMutations();

	const activityActions = getActivityActions(
		{ ...raw, renderType, fromTimestamp, toTimestamp, crewMemberId },
		{
			onUpdateBreak: updateBreak,
		}
	);

	const chipStyles = classNames(styles.activity, styles.regularActivity, styles[renderType], {
		[styles.selected]: isSelected,
		[styles.openStart]: !isStartInTimeWindow,
		[styles.openEnd]: !isEndInTimeWindow,
	});

	const onChipClick = () => {
		const payload = { ...raw, fromTimestamp, toTimestamp };
		if (crewMemberId) payload.crewMemberId = crewMemberId;

		openModalForChip(renderType, payload);
	};

	return (
		<div
			title={suppressNativeTitle ? undefined : header}
			className={chipStyles}
			onClick={onChipClick}
		>
			<ActionMenu items={activityActions} isLoading={loading} />

			<div className={styles.header}>
				<div>{icon}</div>
				<div className={styles.headerText}>{header}</div>
			</div>

			<div className={styles.subline}>{subline}</div>

			<div className={styles.timeRow}>
				<div>{formatTime(fromTimestamp, { timezone })}</div>
				<div className={styles.duration}>
					{getDurationBetweenTimestamps(fromTimestamp, toTimestamp)}
				</div>
				<div>{formatTime(toTimestamp, { timezone })}</div>
			</div>
		</div>
	);
};

export default RestLayout;
